module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.mint.30927c6f.svg";